import { useMemo } from 'react';

/**
 * Extracts public BiQ conversion reference data from the URL fragment.
 *
 * When users visit bloomiq.io, chat with public BiQ, then click Login,
 * the marketing site appends conversion params to the URL fragment:
 *   app.bloomiq.io/login#ref_uid=abc&ref_visitor=xyz&ref_thumb=...&ref_queries=3&ref_source=public_biq
 *
 * Fragment (hash) params are used instead of query params for privacy —
 * they are never sent to the server in HTTP requests.
 *
 * @returns {Object|null} Conversion ref data or null if not from public BiQ
 */
export function useConversionRef() {
  return useMemo(() => {
    try {
      const hash = window.location.hash;
      if (!hash || !hash.includes('ref_source=public_biq')) return null;

      const params = new URLSearchParams(hash.slice(1));
      const source = params.get('ref_source');
      if (source !== 'public_biq') return null;

      return {
        anonymous_uid: params.get('ref_uid') || '',
        visitor_id: params.get('ref_visitor') || '',
        thumbmark_hash: params.get('ref_thumb') || '',
        queries_before_signup: parseInt(params.get('ref_queries') || '0', 10),
        source: 'public_biq',
      };
    } catch {
      return null;
    }
  }, []);
}
